<template>
	<section class="echartBox">
		<car-info></car-info>
		<supplier-info></supplier-info>
	</section>
</template>

<script>
	import carInfo from './carInfo.vue';
	import supplierInfo from './supplierInfo.vue';
	export default {
		components: {
			carInfo,
			supplierInfo
		},
		data() {
			return {

			}
		},
		methods: {

		}
	}
</script>

<style scoped="scoped" lang="scss">
	.echartBox {
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: flex-start;
	}
</style>